
import Vue from "vue";
import XCardBasedForm from "../../components/XCardBasedForm.vue";
import errorService from "../../services/errorService";
import msDataProvider from "@/services/msDataProvider";
import {addAction} from "@/services/firebase/writeData";
import loginService from "@/services/loginService";
export default Vue.extend({
  components: {
    XCardBasedForm,
  },
  data() {
    return {
      errorService,
      loginType: localStorage.getItem('login_type'),
      backendServerName: "",
    };
  },
  methods: {
    async openIdHandler() {
      const prepareResponse = loginService.getPrepareLoginResponse();
      if (!Array.isArray(prepareResponse.available_login_methods)) {
        return;
      }
      const openIdConnect = prepareResponse.available_login_methods.find(method => method.type === 'open_id_connect');
      const authenToken = sessionStorage.getItem("authenToken") || "";
      let authorizedToken = "";
      if (authenToken) {
        authorizedToken = `authorized_token=${authenToken}`;
      }
      const mainPath = location.origin;
      const oauthPathUrl = mainPath + "/ui/oauth-redirect";
      const openIdConnectUrlCallback =
          openIdConnect.redirect_url +
          "?redirect=" +
          mainPath +
          "/ui/oauth-success";
      const urlOauthRedirect =
          oauthPathUrl +
          "?" +
          authorizedToken +
          "&keep_default_url=true&oauth_url=" +
          encodeURIComponent(openIdConnectUrlCallback);
      const response = await msDataProvider.executeCommand("extOpenUrl", {
        url: urlOauthRedirect,
      });
      const error: any = {}
      if (response) {
        error.message = "Login successful"
      } else {
        error.message = "Login failed"
      }
      await addAction(
          "click_to_login_open_id_connect",
          error,
          {
            notLogged: false,
          },
          "login_with_open_id_connect",
          urlOauthRedirect,
      );
    },
  },
  async created() {
    sessionStorage.removeItem("biometricData");
    try {
      this.backendServerName = await msDataProvider.executeCommand(
          "backendServerNameGetCurrentValue"
      );
    } catch (e) {
      this.error = e;
    }
  },
});
